import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import { useRenderViewContext } from '../../../context';
import { ComponenControlWrap } from '../../../controls/shared';
import { ChartTitle } from '../../../controls/chart-title';
import { Legend } from './legend';
import { ScoreType } from './score-type';
import { ValueChains } from './value-chains';

export const RenderViewImpactChartControls = (props: { params: RenderViewImpactChartParams }) => {
  const { params } = props;
  const context = useRenderViewContext();
  const items = context.options.items;
  const showValueChains = items?.length === 1;
  const showLegend = !!items && items.length > 1;
  return (
    <ComponenControlWrap>
      <ChartTitle {...{ params }} defaultTitle={context.getNameOfFirstItem() || ''} />
      <ScoreType {...{ params }} />
      {showValueChains && <ValueChains {...{ params }} />}
      {showLegend && <Legend {...{ params }} />}
    </ComponenControlWrap>
  );
};
